import { ReactComponent as Hand } from 'assets/svg/hand.svg';
import { ModalLayoutProps } from 'components/Modals';
import ModalLayout from 'components/Modals/ModalLayout';
import useAddRequestStore from 'store/addRequestStore';
interface Props extends ModalLayoutProps {
    setCurrentTab: (tab: string) => void;
}

export default function RequestPostedModal({ visible, onClose, setCurrentTab }: Props) {
    const { setRequestPostedModalVisible } = useAddRequestStore();
    return (
        <ModalLayout visible={visible} onClose={onClose} showCloseIcon={false}>
            <div className="w-[500px] md:block hidden  bg-white pt-20 !overflow-hidden">
                <div className="flex gap-4  justify-center items-center flex-col px-4">
                    <Hand />
                    <h2 className="text-base font-semibold text-light-black/90">Your Buyer Request Has Been Posted To The Buyer Pool! </h2>

                    <p className="text-light-black/80 font-normal mb-6 text-center">
                        Your request is now ready to attract the best matches from online and off-market listings of other agents.
                    </p>

                    {/* Buttons */}
                    <div className="flex flex-col w-full gap-3 mb-5">
                        <button
                            className="w-full px-4 py-3 bg-gray-50/50 border border-gray-300 text-my-blue rounded-lg  font-medium"
                            onClick={() => {
                                setRequestPostedModalVisible(false);
                                setCurrentTab('My Requests');
                            }}
                        >
                            View My Requests
                        </button>
                        <button className="w-full px-4 py-2.5 text-gray-600  font-medium" onClick={() => setRequestPostedModalVisible(false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </ModalLayout>
    );
}
